<style lang="less" scoped>
.query-title-div {
  width: 90px !important;
}
.lang-width {
  width: 450px !important;
}
.list-content-div {
  margin-top: 16px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">充电记录详情</div>
      </div>
      <div class="list-content-div">
        <ZD-list-querys>
          <template slot="inputs">
            <div class="list-query-child-div flex">
              <div class="query-title-div">用户手机号</div>
              <div class="query-inputs-div flex-1">
                <el-input
                  size="small"
                  v-model="queryInfo.custPhone"
                  placeholder="请输入内容"
                  clearable
                  @keyup.enter.native="getListData(pagination, true)"
                ></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">订单编号</div>
              <div class="query-inputs-div flex-1">
                <el-input
                  size="small"
                  v-model="queryInfo.orderNo"
                  placeholder="请输入内容"
                  clearable
                  @keyup.enter.native="getListData(pagination, true)"
                ></el-input>
              </div>
            </div>
            <div class="list-query-child-div flex lang-width">
              <div class="query-title-div">充电日期</div>
              <div class="query-inputs-div flex-1">
                <el-date-picker
                  size="small"
                  v-model="time"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleTimeChange"
                ></el-date-picker>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">订单类型</div>
              <div class="query-inputs-div flex-1">
                <el-select size="small" v-model="queryInfo.source" clearable>
                  <el-option label="刷卡订单" value="01"></el-option>
                  <el-option label="APP外部" value="02"></el-option>
                  <el-option label="APP内部" value="03"></el-option>
                  <el-option label="平台" value="04"></el-option>
                </el-select>
              </div>
            </div>
            <div class="list-query-child-div flex">
              <div class="query-title-div">订单属性</div>
              <div class="query-inputs-div flex-1">
                <el-select
                  size="small"
                  v-model="queryInfo.orderProperty"
                  clearable
                >
                  <el-option label="正常" value="01"></el-option>
                  <el-option label="异常" value="02"></el-option>
                </el-select>
              </div>
            </div>
          </template>
          <template slot="actions">
            <button
              class="common-bg-button"
              @click="getListData(pagination, true)"
            >
              搜 索
            </button>
            <button class="common-empty-button" @click="reset()">重 置</button>
          </template>
        </ZD-list-querys>
        <!-- 表格 -->
        <div class="list-table">
          <ZD-table
            :tableColumns="pageConfig.chargeRecordColumns"
            :operates="operates"
            :tableData="tableData"
            :tableConfig="pageConfig.tableConfig"
            :selections="selections"
            v-on:updateSelections="
              (sels) => {
                selections = sels;
              }
            "
          ></ZD-table>
        </div>
        <!-- 分页 -->
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="getListData"
          ></ZD-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig,
      pagination: pageConfig.pagination,
      // 默认值设置
      detailForm: {},
      queryInfo: {},
      pileGunNum: "",
      pileStatusEntity: {},
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      time: [],
      tableData: [], // 表格数据
      selections: [], // 表格选项
    };
  },
  methods: {
    init() { 
        this.daysHandler()
      
      this.getFormInfo();
     
     
    },
    getTime() {
      var date = new Date();
      var year = date.getFullYear(); //年
      var month = date.getMonth() + 1; //月
      var mon = "";
      var day = "";
      var hour = "";
      var minute = "";
      var second = "";
      if (month < 10) {
        mon = "0" + month;
      } else {
        mon = month;
      }
      var daily = date.getDate(); //日
      if (daily < 10) {
        day = "0" + daily;
      } else {
        day = daily;
      }
      // var a = date .getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
      var hours = date.getHours(); //获取当前小时数(0-23)
      if (hours < 10) {
        hour = "0" + hours;
      } else {
        hour = hours;
      }
      var minutes = date.getMinutes(); //获取当前分钟数(0-59)
      if (minutes < 10) {
        minute = "0" + minutes;
      } else {
        minute = minutes;
      }
      var seconds = date.getSeconds(); //获取当前秒数(0-59)
      if (seconds < 10) {
        second = "0" + seconds;
      } else {
        second = seconds;
      }
      var time =
        year + "-" + mon + "-" + day + " " + hour + ":" + minute + ":" + second;
      console.log(time);
      return time;
    },

    daysHandler() {
      //近24小时
      let nowTime = this.getTime();
      var a = nowTime.split(" ");
      var b = a[0].split("-");
      var c = b[2] - 1;
      var m = "";
      if (c <= 0) {
        var n = a[0].split("-");
        c = n[1] - 1;
        m = n[0] + "-" + c + "-" + "30" + " " + a[1];
      } else {
        m = b[0] + "-" + b[1] + "-" + c + " " + a[1];
      }
     this.time = [m,nowTime]
     this.queryInfo.dtFrom = this.time[0];
        this.queryInfo.dtTo = this.time[1];
    //  console.log(nowTime,m);
    },

    // 获取表单信息
    getFormInfo() {
      let _ = this;
      _.$S.getFormInfo(
        _,
        _.$A.pile.list + "/" + _.$store.state.editId,
        function(res) {
          _.detailForm = res.data.data;
          //  _.queryInfo.pileNo = _.detailForm.pileNo;
          _.queryInfo.pileCode = _.detailForm.pileCode;
          _.queryInfo.gunPort = _.detailForm.gunPort;
          _.getListData(_.pagination, true);
        }
      );
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.$H.get(_, _.$A.pile.pileorder, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    handleTimeChange(val) {
      if (val) {
        this.queryInfo.dtFrom = val[0];
        this.queryInfo.dtTo = val[1];
      } else {
        delete this.queryInfo.dtFrom;
        delete this.queryInfo.dtTo;
      }
    },
    reset() {
      delete this.queryInfo.dtFrom;
      delete this.queryInfo.dtTo;
      delete this.queryInfo.custPhone;
      delete this.queryInfo.orderNo;
      delete this.queryInfo.source;
      delete this.queryInfo.orderProperty;
      this.time = [];
      this.getListData(this.pagination);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
